import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createErrorReportingAsyncThunk } from "../../helpers";
import {
  getRentalInvoiceTemplate,
  RentalInvoiceTemplateData,
} from "../../../pages/SettingsPage/FinancePage/invoice-templates/rental-invoice-template-api";

const prefix = "data/rental-invoice-template";

type State = {
  template: RentalInvoiceTemplateData | null;
  availableFields: string[];
  loading: boolean;
};

const initialState: State = {
  template: null,
  availableFields: [],
  loading: false,
};

export const loadRentalInvoiceTemplate = createErrorReportingAsyncThunk(
  `${prefix}/load`,
  async () => await getRentalInvoiceTemplate()
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {
    setRentalInvoiceTemplate: (
      state,
      action: PayloadAction<RentalInvoiceTemplateData>
    ) => {
      state.template = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadRentalInvoiceTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadRentalInvoiceTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.template = action.payload.template;
        state.availableFields = action.payload.availableFields;
      })
      .addCase(loadRentalInvoiceTemplate.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setRentalInvoiceTemplate } = slice.actions;
export default slice.reducer;
